export const onlyNumbers = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
  };
  export const onlyDateTime = (e) => {
    e.target.value = e.target.value.replace(/[^]/g, "");
  };
  export const onlyEmail = (email) => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    return pattern.test(email);
  };
  export const onlyPassword = (password) => {
    var pattern = new RegExp(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/
    );
    return pattern.test(password);
  };
  export const getNumberWithOrdinal = (n) => {
    var s = ["th", "st", "nd", "rd"],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  /**
   * Strips emojis, non-Latin unicode (Devanagari, CJK, Arabic, etc.),
   * and other multi-byte characters that cause MySQL encoding errors.
   * Allows basic ASCII printable characters, common Latin accented letters,
   * and standard whitespace/newlines.
   */
  export const stripUnsafeChars = (value) => {
    if (typeof value !== "string") return value;
    // Allow ASCII printable (space to ~), tabs, newlines, and Latin-1 Supplement (accented chars)
    return value.replace(/[^\x20-\x7E\t\n\r\xA0-\xFF]/g, "").trim();
  };

  /**
   * Checks if a string contains unsafe characters (emojis, non-Latin unicode, etc.)
   * Returns true if unsafe characters are found.
   */
  export const hasUnsafeChars = (value) => {
    if (typeof value !== "string") return false;
    return /[^\x20-\x7E\t\n\r\xA0-\xFF]/.test(value);
  };
  